export default __webpack_public_path__ + "static/media/b1.d44f39a6.png";